import { Badge, Card, Divider, Flex, Grid, Paper, Text, Title } from '@mantine/core';
import React from 'react';
import GridCell from '../../../components/elements/GridCell';
import ListInfoBlock from './ListInfoBlock';
import HistoryBlock from '../../../components/fragments/HistoryBlock';
import CardSupportingDocument from './CardSupportingDocument';
import dayjs from 'dayjs';
import { fetchHistoryBlock } from '../actions';
import PropTypes from 'prop-types';

const FoundCustomer = ({
  data = {},
  dispatch = () => {},
  isLoadingHistory = false,
  historyBlock = []
}) => {
  const STYLE_BADGE_STATUS = [
    null,
    { b: '#E0FFE3', c: '#44AB4A', text: 'Disetujui' },
    { b: '#FBE5E6', c: '#CF212A', text: 'Ditolak' },
  ];
  const dataIdentity = [
    {
      label: 'Nama', value: data?.name || '-'
    },
    {
      label: 'NIK KTP', value: data?.nationalityId || '-'
    },
    {
      label: 'Jenis Pengguna', value: data?.customerTypes?.join(', ') || '-'
    },
    {
      // custom bg & color for rejected
      //  | b="#FBE5E6" c="#CF212A"
      label: 'Status Pengajuan', value: <Flex align="center" gap="xs">
      : <Badge bg={STYLE_BADGE_STATUS[data.status-1]?.b || 'gray'} c={STYLE_BADGE_STATUS[data?.status-1]?.c || 'white'} fw={400} tt="none">
          {
            STYLE_BADGE_STATUS[data?.status-1]?.text || '-'
          }</Badge></Flex>
    }
  ];
  const detailUnblockContent = [
    { label: 'Waktu Penyelesaian', value: <Text fw={500} fz={18}>{data?.updatedAt ? dayjs(data?.updatedAt).locale('id').format('DD MMMM YYYY | HH:mm') : '-'}</Text> },
    { label: 'Admin', value: <Text fw={500} fz={18}>{data?.claimedBy?.name || '-'}</Text> },
    { label: 'Jenis Blokir', value: <Text fw={500} fz={18}>{data?.blockedType === 1 ? 'Diblokir Sistem' : 'Diblokir Admin'}</Text> },
    // custom bg & color for rejected
    //  | b="#FBE5E6"
    { label: `Alasan ${data?.status === 2 ? 'Menyetujui' : 'Menolak'} Pengajuan Pelanggan`, value: <Paper bg={data?.status === 2 ? '#EBF1E1': '#FBE5E6'} fw={500} fz={18} p={8} radius={8}>
      {data?.unblockReason || '-'}
    </Paper> },
  ];
  return (
    <Card w="100%" withBorder>
      <Flex align="center" justify="space-between">
        <Title order={4}>Data Pelanggan</Title>
        <HistoryBlock historyBlock={historyBlock} isLoading={isLoadingHistory}
          onClick={() => dispatch(fetchHistoryBlock({
            nationalityId: data?.nationalityId,
            isMask: true
          }))}/>
      </Flex>
      <Card.Section>
        <Divider my="md"/>
      </Card.Section>
      {
        dataIdentity.map((item, idx) => (
          <GridCell data={item.value} key={idx+item.value} label={item.label} left={3}/>
        ))
      }
      <Card mt="md" w="100%" withBorder>
        <Grid align="center" gap="sm">
          <Grid.Col span={data?.documentSupportAdmin ? 8.7 : 12}>
            <Title mb={12} order={5}>Rincian Penyelesaian Buka Blokir</Title>
            {detailUnblockContent.map((item,idx) => (
              <React.Fragment key={idx}>
                <ListInfoBlock label={item.label} value={item.value} />
                {idx < detailUnblockContent.length - 1 && <Divider my="sm" />}
              </React.Fragment>
            ))}
          </Grid.Col>
          {data?.documentSupportAdmin && <CardSupportingDocument data={{
            documentSupport: data?.documentSupportAdmin
          }}/>}
        </Grid>
      </Card>
    </Card>
  );
};

export default FoundCustomer;
FoundCustomer.propTypes = {
  data: PropTypes.object,
  dispatch: PropTypes.func,
  historyBlock: PropTypes.array,
  isLoadingHistory: PropTypes.bool
};

